/** Maps each add-channel catalog key to a tab / section id (excluding "all"). */
export const CHANNEL_KEY_TO_CATEGORY = {
  website: 'live_chat',
  facebook: 'business_messaging',
  whatsapp: 'business_messaging',
  whatsapp_browser: 'business_messaging',
  sms: 'sms',
  email: 'email',
  api: 'business_messaging',
  telegram: 'business_messaging',
  line: 'business_messaging',
  instagram: 'business_messaging',
  tiktok: 'business_messaging',
  voice: 'calls',
};

/** Section order when the "All" tab lists grouped categories. */
export const CATEGORY_SECTION_ORDER = [
  'business_messaging',
  'calls',
  'sms',
  'email',
  'live_chat',
];

const TONE_CLASSES = {
  success:
    'border border-n-teal-7 bg-n-teal-4 text-n-teal-11 dark:border-n-teal-7 dark:bg-n-teal-5 dark:text-n-teal-12',
  info: 'border border-n-blue-7 bg-n-blue-4 text-n-blue-11 dark:border-n-blue-7 dark:bg-n-blue-5 dark:text-n-blue-12',
  violet:
    'border border-n-violet-7 bg-n-violet-4 text-n-violet-11 dark:border-n-violet-7 dark:bg-n-violet-5 dark:text-n-violet-12',
  warning:
    'border border-n-amber-7 bg-n-amber-4 text-n-amber-11 dark:border-n-amber-7 dark:bg-n-amber-5 dark:text-n-amber-12',
  neutral:
    'border border-n-weak bg-n-slate-3 text-n-slate-11 dark:border-n-strong dark:bg-n-slate-5 dark:text-n-slate-12',
  ruby: 'border border-n-ruby-7 bg-n-ruby-4 text-n-ruby-11 dark:border-n-ruby-7 dark:bg-n-ruby-5 dark:text-n-ruby-12',
};

export function badgeToneClass(tone) {
  return TONE_CLASSES[tone] || TONE_CLASSES.neutral;
}

/**
 * Normalizes InstallationConfig / window.globalConfig value for CHANNEL_CATALOG_BADGES.
 * @returns {Record<string, { emoji?: string, text?: string, tone?: string, icon?: string }>}
 */
export function parseChannelCatalogBadges(raw) {
  if (raw === undefined || raw === null) return {};
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed || trimmed === '{}') return {};
    try {
      const parsed = JSON.parse(trimmed);
      return typeof parsed === 'object' && parsed !== null ? parsed : {};
    } catch {
      return {};
    }
  }
  if (typeof raw === 'object') return { ...raw };
  return {};
}

/**
 * Mirrors dashboard ChannelItem.vue — whether the channel can be selected in the catalog.
 * @param {string} key - channel key (website, facebook, …)
 * @param {Record<string, boolean>} enabledFeatures - account.features
 * @param {{ fbAppId?: string, instagramAppId?: string, tiktokAppId?: string }} oauth - from window.chatwootConfig
 */
export function isChannelCatalogItemActive(key, enabledFeatures, oauth) {
  const ef = enabledFeatures || {};
  if (Object.keys(ef).length === 0) return false;

  if (key === 'website') return Boolean(ef.channel_website);
  if (key === 'facebook') {
    return Boolean(ef.channel_facebook && oauth?.fbAppId);
  }
  if (key === 'email') return Boolean(ef.channel_email);
  if (key === 'instagram') {
    return Boolean(ef.channel_instagram && oauth?.instagramAppId);
  }
  if (key === 'tiktok') {
    return Boolean(ef.channel_tiktok && oauth?.tiktokAppId);
  }
  if (key === 'voice') return Boolean(ef.channel_voice);

  return [
    'website',
    'twilio',
    'api',
    'whatsapp',
    'whatsapp_browser',
    'sms',
    'telegram',
    'line',
    'instagram',
    'tiktok',
    'voice',
  ].includes(key);
}

export function isChannelCatalogComingSoon(key, isActive) {
  return key === 'voice' && !isActive;
}
